import styled from 'styled-components'

import { bordergray, inputgray } from '../../../styles/colors'

export const Intro = styled.div`
  width: 100%;
  padding: 1rem;
  border-bottom: 1px solid ${bordergray};
`

export const IntroTitle = styled.div`
  font-size: 18px;
  line-height: 1.5;
`

export const IntroSubtitle = styled.div`
  margin-top: .5rem;
  font-size: 18px;
  color: ${inputgray};
`



// WEBPACK FOOTER //
// ./src/components/Header/UserMenu/styles.js